var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTcCabApostolRadar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 115,
    viewBox: "0 0 115 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 57.5,
    cy: 57.5,
    r: 56.5,
    stroke: "#00686D",
    strokeOpacity: 0.35,
    strokeWidth: 1.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 57.5,
    cy: 57.5,
    r: 45,
    stroke: "#00686D",
    strokeOpacity: 0.5,
    strokeWidth: 1.2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 57.5,
    cy: 57.5,
    r: 33.5,
    stroke: "#00686D",
    strokeOpacity: 0.7,
    strokeWidth: 1.2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 57.5,
    cy: 57.5,
    r: 22,
    stroke: "#36F6FF",
    strokeOpacity: 0.45,
    strokeWidth: 1.2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 57.5,
    cy: 57.5,
    r: 12.5,
    fill: "#031018",
    stroke: "#36F6FF",
    strokeOpacity: 0.9,
    strokeWidth: 1.2
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 57.5,
    cy: 54.6,
    r: 3,
    fill: "#36F6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.3 63c0-2.7 2.33-4.6 5.2-4.6s5.2 1.9 5.2 4.6H52.3Z",
    fill: "#36F6FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTcCabApostolRadar);
export default __webpack_public_path__ + "static/media/tc_cab_apostol_radar.40e86d56b430759aa69125dc406c8285.svg";
export { ForwardRef as ReactComponent };